import React from 'react'
import styles from './iconStyles.module.scss'

export default function FaChevronDown() {
  return (
    <div className={styles.FaChevronDown} />
  )
}
